import Vue from "vue";
import VueLocalStorage from "vue-localstorage"
import axios from "axios";
import config from "@/config";

Vue.use(VueLocalStorage);

axios.defaults.baseURL = config.host;

/**
 * 网络请求异常处理
 * @param {*} error
 * @param {*} reject
 */
const responseError = (error, reject) => {
  reject({
    ret: false,
    data: "",
    msg: "网络错误，请重试！"
  });
};

/**
 * 请求成功处理
 * @param {*} response
 * @param {*} resolve
 * @param {*} reject
 */
const responseSuccess = (response, resolve, reject) => {
  const res = response.data;
  if (res.ret) {
    resolve(res.data);
  } else {
    reject(res);
  }
};

/**
 * @desc 获取get请求
 * @param {*} url
 * @param {*} query
 */
export const reqGet = (url, query = {}) => {
  let headers = {
    "Content-Type": "application/json",
  };
  headers.authorization = Vue.localStorage.get("token");
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      headers: headers,
      params: query,
      method: "get",
    })
      .then((res) => responseSuccess(res, resolve, reject))
      .catch((error) => responseError(error, reject));
  });
};

/**
 * @desc 获取get请求
 * @param {*} url
 * @param {*} params
 */
export const reqPost = (url, params = {}) => {
  let headers = {
    "Content-Type": "application/json",
  };
  headers.authorization = Vue.localStorage.get("token");
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      headers: headers,
      data: params,
      method: "post",
    })
      .then((res) => responseSuccess(res, resolve, reject))
      .catch((error) => responseError(error, reject));
  });
};

/**
 * @desc 文件上传
 * @param {*} url
 * @param {*} formData
 */
export const reqUpload = (url, formData) => {
  let headers = {
    'Content-Type': 'multipart/form-data'
  }
  headers.authorization = Vue.localStorage.get("token");
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: 'POST',
      headers: headers,
      data: formData
    })
      .then(res => responseSuccess(res, resolve, reject))
      .catch(error => responseError(error))
  })
}